import React, {
  createContext,
  PropsWithChildren,
  ReactElement,
  useContext,
} from "react";
import { ContextWithJaeger, ExtendedNextPageContext } from "types/app";
import { createApi as createGraphqlApi } from "./providers/graphql";

const isServer = typeof window === "undefined";
let apiOnClient: API;

export type API = ReturnType<typeof createGraphqlApi>;

/* todo: rework for multiple providers, if needed */
export const createNextContextApi = (
  ctx: ContextWithJaeger<ExtendedNextPageContext>
): void => {
  if (isServer) {
    ctx.api = createGraphqlApi(ctx);
    return;
  }

  if (!apiOnClient) {
    apiOnClient = createGraphqlApi(ctx);
  }

  ctx.api = apiOnClient;
};

export const createNewContextLessApi = () => {
  return createGraphqlApi();
};

export const createApi = (): API => {
  if (isServer) {
    return createGraphqlApi();
  }

  if (!apiOnClient) {
    apiOnClient = createGraphqlApi();
  }

  return apiOnClient;
};

export const createApiWithContext = (
  ctx: Pick<ExtendedNextPageContext, "req" | "res">
): API => {
  return createGraphqlApi(ctx);
};

export const ApiContext = createContext(undefined);

export const useApi = (): API => {
  const context = useContext(ApiContext);
  if (context === undefined) {
    throw new Error("useApi must be used within ApiProvider");
  }

  return context;
};

type ApiProviderProps = {
  api: API;
};

export function ApiProvider({
  children,
  api,
}: PropsWithChildren<ApiProviderProps>): ReactElement {
  return React.createElement(
    ApiContext.Provider,
    {
      value: api,
    },
    children
  );
}
